import { API_START, API_END, API_ERROR } from "./types";

export const apiStart = () => {
	return {
		type: API_START
	};
};

export const apiEnd = () => {
	return {
		type: API_END
	};
};

export const apiError = (error, language) => {
	console.error("API Error detailed:", error);
	return {
		type: API_ERROR,
		payload: { error, language }
	};
};
